// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yEWi","textarea":"styles_textarea__1xjDx"};